// const MatchPage = () => import('./list/MatchPage.vue');

import MatchPage from "./list/MatchPage.vue";

const routes = [
  {
    path: '/',
    redirect: 'matches'
  },
  {
    path: '/matches',
    name: 'matches',
    component: MatchPage,
    meta: {
      title: 'match',
      requiresAuth: true,
      headerColor: '#4b4ced'
    }
  }
];

export default routes;
